export default {
  EmailFormField__ARIA: "email address",
  EmailFormField__LABEL: "Email address",
};
